// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1eAm7","header":"MergedInvoice_header__1eRM3"};